import Axios from "../helper/axios";
import { urls } from "../constants/constants";

const axios1 = require("axios");
const axios = new Axios();

export default class CommonService {
  clearChat(data) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/patient/archivePatient`,
      data: data,
    };
    return axios.put(option);
  }
  checkDuplicatedEntry(data) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/checkDuplicateEntry`,
      data: data,
    };
    return axios.post(option);
  }
  getLivechatConfiguration() {
    const option = {
      url: `${urls.aspariaBackend}api/v1/getLivechatConfiguration`,
    };
    return axios.get(option);
  }
  uploadPatientCSV(data) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/patient/upload`,
      data: data,
      processData: false,
      mimeType: "text/csv",
      headers: {
        Authorization: `Bearer `, // Authorization: `Bearer ${loginService.getToken() || undefined}`,
        "Access-Control-Allow-Origin": "*",
      },
    };
    option.method = "POST";
    return new Promise((resolve, reject) => {
      axios1(option)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  chatSendLink(id) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/patient/sendUploadLink/${id}`,
    };
    return axios.get(option);
  }

  fetchAppointmentData() {
    const option = {
      url: `${urls.aspariaBackend}api/v1/user/getAppointmentStatus`,
    };
    return axios.get(option);
  }

  getReportsList(pageNo = 1, pageSize = 15, sort = "", filter = "") {
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/patient/reportsList?pageNo=${pageNo}&pageSize=${pageSize}${
        sort ? `&sort=${sort}` : ""
      }${filter ? `&filter=${filter}` : ""}`,
    };
    return axios.get(option);
  }

  getBroadcastList(pageNo = 1, pageSize = 15, sort = "", filter = "") {
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/broadcast/getBroadcastList?pageNo=${pageNo}&pageSize=${pageSize}${
        sort ? `&sort=${sort}` : ""
      }${filter ? `&filter=${filter}` : ""}`,
    };
    return axios.get(option);
  }

  getReportsListSuggestions(column, value) {
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/patient/columnData?attribute=${column}&value=${value}`,
    };
    return axios.get(option);
  }

  getBroadcastListSuggestions(column, value) {
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/broadcast/columnData?attribute=${column}&value=${value}`,
    };
    return axios.get(option);
  }

  patientReportfile(id) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/patient/fileDownload/${id}`,
    };
    return axios.get(option);
  }
  fetchPreviewData(link) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/getLinkPreview?key=${link}`,
    };
    return axios.get(option);
  }
  saveTemplateData(templateName, templateMessage, type, showAs, accounts) {
    const data = {
      templateName,
      templateMessage,
      type,
      showAs,
      ...(accounts ? { accounts } : {}),
    };
    const option = { url: `${urls.aspariaBackend}api/v1/template`, data: data };
    return axios.post(option);
  }
  getTemplateList(type) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/template?type=${type}`,
    };
    return axios.get(option);
  }
  getTemplateMsg(id) {
    const option = { url: `${urls.aspariaBackend}api/v1/template/${id}` };
    return axios.get(option);
  }

  saveBroadcastSchedule(data) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/broadcast/scheduleMessage`,
      data: data,
    };
    return axios.post(option);
  }

  getOverridewindow(convoType) {
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/broadcast/checkContactWindow/${convoType}`,
    };
    return axios.get(option);
  }

  editTemplate(data, templateId) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/template/${templateId}`,
      data: data,
    };
    return axios.put(option);
  }

  deleteBroadcast(data) {
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/broadcast/scheduleMessage?transactionId=${data}`,
    };
    return axios.delete(option);
  }

  updateBroadcastSchedule(data) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/broadcast/scheduleMessage`,
      data: data,
    };
    return axios.put(option);
  }

  getScheduleById(id) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/broadcasttransaction/${id}`,
    };
    return axios.get(option);
  }

  killBroadcast(id) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/broadcast/kill`,
      data: { transactionId: id },
    };
    return axios.put(option);
  }

  sendNow(id, isTwilioDisabled, countryCodeForRcs) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/broadcast/sendNow`,
      data: { transactionId: id, isTwilioDisabled, countryCodeForRcs },
    };
    return axios.post(option);
  }

  deleteTemplate(id) {
    const option = { url: `${urls.aspariaBackend}api/v1/template/${id}` };
    return axios.delete(option);
  }

  deleteEmailTemplate(id) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/broadcast/emailTemplate?id=${id}`,
    };
    return axios.delete(option);
  }

  clearChatLiveAgent() {
    const option = {
      url: `${urls.aspariaBackend}api/v1/livechat-agent/clearAll`,
    };
    return axios.delete(option);
  }

  getSecureChatLink(id) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/securedChat/generateLink/${id}`,
    };
    return axios.get(option);
  }
  getSecureSession(id) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/securedChat/getSecureSession/${id}`,
    };
    return axios.get(option);
  }

  getSecureChatSessionTime() {
    const option = {
      url: `${urls.aspariaBackend}api/v1/securedChat/getSessionTime`,
    };
    return axios.get(option);
  }

  endSecureSession(sessionId) {
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/securedChat/endSecureSession/${sessionId}`,
    };
    return axios.delete(option);
  }

  getSurveyTemplate(practiceId) {
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/surveyTemplateDropdown?practiceId=${practiceId}`,
    };
    return axios.get(option);
  }

  getLanguageVoicesByCustomer(practiceId) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/customers/lang-voices/${practiceId}`,
    };
    return axios.get(option);
  }

  checkTemplateExists(name, type, accounts = []) {
    const options = {
      url: `${urls.aspariaBackend}api/v1/templates/exists`,
      data: {
        name,
        type,
        accounts,
      },
    };
    return axios.post(options);
  }
}
